import api from '../services/config/api';

export const changeStatusUser = (userId: number, enabled: boolean) =>
  api.delete(`/user/${userId}?enabled=${enabled}`);
